import { useTheme } from '@mui/material';

const SceneSvg = (props: { fill?: string }) => {
    return (
        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 1V2H12V1C12 0.45 11.55 0 11 0H5C4.45 0 4 0.45 4 1V2H2V1C2 0.45 1.55 0 1 0C0.45 0 0 0.45 0 1V17C0 17.55 0.45 18 1 18C1.55 18 2 17.55 2 17V16H4V17C4 17.55 4.45 18 5 18H11C11.55 18 12 17.55 12 17V16H14V17C14 17.55 14.45 18 15 18C15.55 18 16 17.55 16 17V1C16 0.45 15.55 0 15 0C14.45 0 14 0.45 14 1ZM4 14H2V12H4V14ZM2 10H4V8H2V10ZM4 6H2V4H4V6ZM12 14H14V12H12V14ZM14 10H12V8H14V10ZM12 6H14V4H12V6Z"
                fill={props.fill || '#FAFAFA'}
            />
        </svg>
    );
};
const SceneTitleSvg = (props: { fill?: string }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9 1H15M9 9H15M9 5H21M9 13H21M3 5C1.89543 5 1 4.10457 1 3C1 1.89543 1.89543 1 3 1C4.10457 1 5 1.89543 5 3C5 4.10457 4.10457 5 3 5ZM3 13C1.89543 13 1 12.1046 1 11C1 9.89543 1.89543 9 3 9C4.10457 9 5 9.89543 5 11C5 12.1046 4.10457 13 3 13Z"
                stroke={props.fill || '#A1A1AA'}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};
const SceneCharactersSvg = (props: { fill?: string }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_551_596161)">
                <path
                    d="M10.7032 3.80672V4.329C11.4279 4.27992 11.8159 4.3387 11.8562 4.34527C11.971 4.36402 12.0796 4.41049 12.1724 4.48065C12.2653 4.55081 12.3396 4.64255 12.389 4.74792L13.4074 6.91847C13.5347 6.94781 13.6515 7.01153 13.7451 7.10269C13.8679 7.22241 14.015 7.31616 14.1816 7.3568C14.5143 7.43789 14.8444 7.34545 15.0777 7.11858C15.3185 6.88458 15.6858 6.82509 15.9696 7.00453C16.3754 7.26084 16.419 7.80394 16.1007 8.12217C15.6518 8.57133 15.0547 8.81873 14.4195 8.81873C14.3787 8.8187 14.338 8.81765 14.2974 8.81559L15.6664 11.7338C15.724 11.8564 15.7789 11.9802 15.831 12.1053C17.3726 11.6191 19.126 11.9802 20.3512 13.1915C20.6251 13.4621 20.6555 13.9041 20.3995 14.192C20.3323 14.2679 20.2498 14.3287 20.1573 14.3702C20.0648 14.4118 19.9646 14.4332 19.8632 14.4331C19.6799 14.4331 19.4965 14.3632 19.3567 14.2233C18.5263 13.3931 17.3342 13.1406 16.2831 13.4645C16.6817 15.0538 16.6552 16.6941 16.2437 18.2322C16.4386 18.2966 16.6358 18.3537 16.835 18.4032C17.0675 18.461 17.3106 18.4613 17.5433 18.4039C21.1261 17.5177 23.6775 14.2956 23.6775 10.5626V3.80672C23.6775 3.47217 23.4709 3.17227 23.1578 3.05452C22.1711 2.68378 20.264 2.17969 17.1906 2.17969C14.1169 2.17969 12.2097 2.68397 11.2228 3.05475C10.9097 3.17231 10.7031 3.47222 10.7031 3.80677L10.7032 3.80672ZM18.6237 7.10906C18.9036 6.82927 19.3571 6.82927 19.6371 7.10906C19.7246 7.19705 19.8286 7.26681 19.9433 7.3143C20.0579 7.3618 20.1808 7.38609 20.3049 7.38577C20.429 7.38609 20.5519 7.3618 20.6666 7.31431C20.7812 7.26681 20.8853 7.19705 20.9728 7.10906C21.2526 6.82913 21.7063 6.82913 21.9861 7.10906C22.2659 7.38886 22.2659 7.84242 21.9861 8.12217C21.537 8.57133 20.9401 8.81873 20.3049 8.81873C19.6698 8.81873 19.0727 8.57133 18.6236 8.12217C18.344 7.84242 18.344 7.38886 18.6237 7.10906Z"
                    fill={props.fill || '#FAFAFA'}
                />
                <path
                    d="M14.3715 12.3424L11.4866 6.19371C11.3539 5.91059 11.0598 5.74015 10.748 5.76377C9.70628 5.84252 7.75239 6.18799 4.93806 7.50841C2.15537 8.81393 0.642906 10.0804 -0.0929379 10.8352C-0.326375 11.0748 -0.386094 11.434 -0.244016 11.7369L2.62544 17.8531C4.21094 21.2325 7.88969 23.0659 11.5099 22.3464C11.7439 22.2999 11.9629 22.1971 12.1482 22.0468C15.0156 19.7228 15.957 15.7219 14.3715 12.3424ZM8.57397 11.8841C9.01947 10.6511 10.3851 10.0102 11.6181 10.4559C11.9902 10.5903 12.1828 11.001 12.0484 11.3732C11.914 11.7453 11.5033 11.9381 11.131 11.8035C10.6412 11.6266 10.0987 11.8811 9.92167 12.3709C9.8162 12.6628 9.54114 12.8443 9.2478 12.8443C9.16689 12.8443 9.08467 12.8306 9.00428 12.8014C8.63219 12.6669 8.43939 12.2561 8.57397 11.8841V11.8841ZM5.80305 14.3033C5.68643 14.2608 5.56253 14.2418 5.43854 14.2475C5.31455 14.2533 5.19292 14.2835 5.0807 14.3366C4.96822 14.3889 4.86726 14.4631 4.78365 14.5548C4.70004 14.6465 4.63545 14.7539 4.59363 14.8707C4.48816 15.1626 4.21295 15.344 3.91961 15.344C3.83884 15.344 3.75667 15.3301 3.67628 15.3012C3.304 15.1668 3.11139 14.756 3.24578 14.3838C3.46169 13.7865 3.89711 13.309 4.47203 13.0393C5.04719 12.7696 5.69266 12.7398 6.28994 12.9556C6.66213 13.09 6.85478 13.5007 6.72039 13.873C6.58581 14.2451 6.17509 14.4377 5.80305 14.3033ZM8.20886 18.9867C7.68928 18.9866 7.1737 18.896 6.68523 18.7188C6.313 18.5845 6.12039 18.1737 6.25478 17.8015C6.38931 17.4294 6.79984 17.2366 7.17212 17.3712C8.76091 17.9452 10.5205 17.1196 11.0946 15.531C11.229 15.1587 11.6397 14.9661 12.012 15.1005C12.384 15.2351 12.5767 15.6458 12.4423 16.0181C11.7814 17.8467 10.05 18.9867 8.20886 18.9867Z"
                    fill={props.fill || '#FAFAFA'}
                />
            </g>
            <defs>
                <clipPath id="clip0_551_596161">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
const SceneLoglineSvg = (props: { fill?: string }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                clipRule="evenodd"
                d="M11.25 4.37808C9.13095 2.92228 6.18953 2.25933 3.99433 2.01127C2.89642 1.88721 2 2.80402 2 3.93518V15.2C2 16.3311 2.89642 17.2483 3.99433 17.3723C6.18953 17.6204 9.13095 18.2833 11.25 19.7391V4.37808ZM12.75 19.7391C14.869 18.2833 17.8105 17.6204 20.0057 17.3723C21.1036 17.2483 22 16.3311 22 15.2V3.93518C22 2.80402 21.1036 1.88721 20.0057 2.01127C17.8105 2.25933 14.869 2.92228 12.75 4.37808V19.7391ZM4.25882 7.13996C4.32221 6.73063 4.70543 6.45019 5.11477 6.51358C6.41754 6.71534 7.88469 7.05257 9.27049 7.58846C9.65682 7.73786 9.8489 8.17215 9.6995 8.55849C9.55011 8.94482 9.11581 9.1369 8.72948 8.9875C7.47083 8.50078 6.11398 8.18621 4.8852 7.99591C4.47587 7.93252 4.19543 7.5493 4.25882 7.13996ZM5.11477 10.5136C4.70543 10.4502 4.32221 10.7306 4.25882 11.14C4.19543 11.5493 4.47587 11.9325 4.8852 11.9959C5.50444 12.0918 6.15812 12.2196 6.81651 12.3857C7.21814 12.487 7.62587 12.2436 7.7272 11.8419C7.82853 11.4403 7.58509 11.0326 7.18346 10.9313C6.47445 10.7524 5.7745 10.6158 5.11477 10.5136Z"
                fill={props.fill || '#FAFAFA'}
            />
        </svg>
    );
};
const SceneActionSvg = (props: { fill?: string }) => {
    return (
        <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.0599 5.12832C15.2042 4.86529 15.9129 3.74864 15.6428 2.63421C15.3727 1.51979 14.2261 0.829595 13.0818 1.09262C11.9374 1.35565 11.2287 2.4723 11.4988 3.58672C11.7689 4.70115 12.9155 5.39134 14.0599 5.12832Z"
                fill={props.fill || '#FAFAFA'}
            />
            <path
                d="M17.5928 10.9846L14.8909 8.65881L14.5 10.9845L16.284 12.6151C16.7472 12.9668 17.4143 12.8841 17.7755 12.4371C18.1367 11.9861 18.0517 11.3363 17.5928 10.9846Z"
                fill={props.fill || '#FAFAFA'}
            />
            <path
                d="M7.66981 21.3221C7.43185 22.0008 7.80154 22.7374 8.49844 22.9733C9.19534 23.2051 9.95173 22.845 10.1939 22.1664L11.9995 17.0001L9.81108 15.2454L7.67406 21.3263L7.66981 21.3221Z"
                fill={props.fill || '#FAFAFA'}
            />
            <path
                d="M16.292 16.5176L16.275 16.53C16.2283 16.2982 16.173 16.0748 16.1348 16.0003C16.0031 15.7561 15.6716 15.3712 15.6716 15.3712L13.6362 13.7987C13.6362 13.7987 13.3769 13.5587 13.3769 13.2152C13.3769 12.7558 13.4577 12.4413 13.4577 12.4413L14.2991 7.43399C14.2991 7.43399 14.4988 6.21733 12.8798 5.93593C12.2169 5.82005 11.469 6.17181 11.469 6.17181C11.469 6.17181 9.00857 7.39261 8.34141 8.00508C7.95897 8.35683 7.88248 8.85343 7.88248 8.85343L7.61477 10.0908L7.0241 12.731C6.90087 13.2897 7.26207 13.8401 7.83574 13.9601C8.4094 14.0801 8.97457 13.7283 9.0978 13.1697L9.60773 10.8812H9.61198L9.69272 10.4922L9.90944 9.52383C9.96893 9.38313 10.1219 9.08931 10.3301 9.14311C10.4916 9.18449 10.4995 9.50003 10.4995 9.50003L9.88819 12.4413C9.88819 12.4413 9.7947 13.3062 9.84995 13.5918C9.95193 14.1091 10.2919 14.3905 10.2919 14.3905L13.3854 16.9148C13.3854 16.9148 13.6786 17.1135 13.8316 17.3866C13.8954 17.4983 13.9506 17.9329 13.9506 17.9329L14.0313 18.3012L14.5115 21.9222C14.6135 22.634 15.2892 23.1264 16.0158 23.0271C16.7467 22.9278 17.2524 22.2698 17.1504 21.5621L16.2878 16.5217L16.292 16.5176Z"
                fill={props.fill || '#FAFAFA'}
            />
        </svg>
    );
};
const SceneDialogueSvg = (_props: { fill?: string }) => {
    const theme = useTheme();
    return (
        <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0.8"
                d="M11.3452 3.625H10.1878C5.71326 3.625 2.08594 7.29766 2.08594 11.8281V15.3438C2.08594 16.6382 3.12232 17.6875 4.40075 17.6875H11.3452C15.1805 17.6875 18.2896 14.5395 18.2896 10.6562C18.2896 10.0905 18.2237 9.54036 18.099 9.01329C17.3683 5.92256 14.6217 3.625 11.3452 3.625Z"
                fill={theme.palette.mode === 'dark' ? theme.custom.c2 : theme.custom.c4}
            />
            <path
                d="M11.3439 17.6898C15.1792 17.6898 18.2883 14.5418 18.2883 10.6586C18.2883 10.0928 18.2223 9.5427 18.0977 9.01562C20.9373 10.2908 22.9179 13.1702 22.9179 16.518V20.0336C22.9179 21.328 21.8815 22.3773 20.6031 22.3773H13.6587C10.635 22.3773 8.0627 20.4208 7.10938 17.6898H11.3439Z"
                fill={theme.palette.mode === 'dark' ? theme.custom.c2 : theme.custom.c4}
            />
        </svg>
    );
};
const SceneDialogueCharacterSvg = (props: { fill?: string }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM9.49455 14.4362C9.1849 14.1645 8.71354 14.1934 8.43945 14.5017C8.16426 14.8113 8.19215 15.2854 8.50174 15.5606L8.77679 15.7719C8.93912 15.8849 9.17203 16.0306 9.46968 16.1749C10.065 16.4635 10.9268 16.75 12 16.75C13.0733 16.75 13.935 16.4635 14.5303 16.1749C14.828 16.0306 15.0609 15.8849 15.2232 15.7719C15.3045 15.7154 15.3685 15.6668 15.4145 15.6302L15.4983 15.5606C15.8079 15.2854 15.8358 14.8113 15.5606 14.5017C15.2865 14.1934 14.8151 14.1645 14.5055 14.4362L14.3666 14.5406C14.2594 14.6152 14.0939 14.7195 13.8759 14.8251C13.44 15.0365 12.8018 15.25 12 15.25C11.1983 15.25 10.56 15.0365 10.1241 14.8251C9.90611 14.7195 9.74058 14.6152 9.63338 14.5406L9.49455 14.4362ZM17 10C17 10.5523 16.5523 11 16 11C15.4477 11 15 10.5523 15 10C15 9.44772 15.4477 9 16 9C16.5523 9 17 9.44772 17 10ZM8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z"
                fill={props.fill || '#A1A1AA'}
            />
        </svg>
    );
};
const SceneDialogueReplicaSvg = (props: { fill?: string }) => {
    return (
        <svg width="24" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 0H11C15.9706 0 20 4.02944 20 9C20 13.9706 15.9706 18 11 18H4C1.79086 18 0 16.2091 0 14V9C0 4.02944 4.02944 0 9 0ZM6 11.75C5.58579 11.75 5.25 11.4142 5.25 11C5.25 10.5858 5.58579 10.25 6 10.25H10C10.4142 10.25 10.75 10.5858 10.75 11C10.75 11.4142 10.4142 11.75 10 11.75H6ZM6 7.75C5.58579 7.75 5.25 7.41421 5.25 7C5.25 6.58579 5.58579 6.25 6 6.25H14C14.4142 6.25 14.75 6.58579 14.75 7C14.75 7.41421 14.4142 7.75 14 7.75H6Z"
                fill={props.fill || '#A1A1AA'}
            />
        </svg>
    );
};
const SceneDialogueRemarkSvg = (props: { fill?: string }) => {
    return (
        <svg width="24" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.0007 8.995C16.0007 13.0304 14.7851 15.6608 13.0514 17.7333H10.3711C11.5668 16.3184 13.0016 12.9307 13.0016 8.98504C13.0016 5.03935 11.5668 1.67157 10.3711 0.266663H13.0514C14.7751 2.30925 16.0007 4.93971 16.0007 8.995Z"
                fill={props.fill || '#A1A1AA'}
            />
            <path
                d="M0 8.995C0 5.48772 0.926639 2.68788 2.95927 0.266663H5.62958C4.16489 1.98045 2.99912 5.66707 2.99912 8.98504C2.99912 12.303 4.16489 15.9996 5.62958 17.7333H2.95927C0.916675 15.2822 0 12.4824 0 8.995Z"
                fill={props.fill || '#A1A1AA'}
            />
        </svg>
    );
};

const SceneMountingNoteSvg = (props: { fill?: string }) => {
    return (
        <svg width="22" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0H2C0.9 0 0 0.9 0 2V18L7 15L14 18V2C14 0.9 13.1 0 12 0Z" fill={props.fill || '#FAFAFA'} />
        </svg>
    );
};
const SceneDescriptionPepSvg = (props: { fill?: string }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 9H19C19.55 9 20 9.45 20 10C20 10.55 19.55 11 19 11H5C4.45 11 4 10.55 4 10C4 9.45 4.45 9 5 9ZM19 15H5C4.45 15 4 14.55 4 14C4 13.45 4.45 13 5 13H19C19.55 13 20 13.45 20 14C20 14.55 19.55 15 19 15Z"
                fill={props.fill || '#FAFAFA'}
            />
        </svg>
    );
};

const SceneDescription = () => {
    return (
        <svg width="16" height="6" viewBox="0 0 16 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 0H15C15.55 0 16 0.45 16 1C16 1.55 15.55 2 15 2H1C0.45 2 0 1.55 0 1C0 0.45 0.45 0 1 0ZM15 6H1C0.45 6 0 5.55 0 5C0 4.45 0.45 4 1 4H15C15.55 4 16 4.45 16 5C16 5.55 15.55 6 15 6Z"
                fill="#FAFAFA"
            />
        </svg>
    );
};

const ScenePepSvg = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 9H19C19.55 9 20 9.45 20 10C20 10.55 19.55 11 19 11H5C4.45 11 4 10.55 4 10C4 9.45 4.45 9 5 9ZM19 15H5C4.45 15 4 14.55 4 14C4 13.45 4.45 13 5 13H19C19.55 13 20 13.45 20 14C20 14.55 19.55 15 19 15Z"
                fill="#FAFAFA"
            />
        </svg>
    );
};

export {
    SceneActionSvg,
    SceneCharactersSvg,
    SceneDescription,
    SceneDescriptionPepSvg,
    SceneDialogueCharacterSvg,
    SceneDialogueRemarkSvg,
    SceneDialogueReplicaSvg,
    SceneDialogueSvg,
    SceneLoglineSvg,
    SceneMountingNoteSvg,
    ScenePepSvg,
    SceneSvg,
    SceneTitleSvg,
};
